import React from "react";
import {UserDetails} from "../UserDetails/UserDetails";
import {jobTitles} from "../../../SiteConfig/jobTitles";
import {locations} from "../../../Utilities/Location";
import {allow, policyEvents} from "../../../Components/Authorize";

import type {User} from "../../../types";

interface UserProfileViewProps {
    districts: { id: string; districtName: string }[];
    handleEditUser: (user: Record<string, unknown>) => void;
    isLoading: boolean;
    patronDetails: User;
    redirect: (path: string) => void;
    setWarnings: (val: string[]) => void;
}

export const UserProfileView: React.FC<UserProfileViewProps> = ({
                                    districts,
                                    handleEditUser,
                                    isLoading,
                                    patronDetails,
                                    redirect,
                                    setWarnings,
                                }) => {


    const handleCancel = () => {
        allow(policyEvents.APPROVE_USERS) ? redirect(locations.USER_MANAGEMENT.path) : redirect(locations.DASHBOARD.path);
    }

    return <>
        <UserDetails
            districts={districts}
            handleCancel={handleCancel}
            handleManageUser={handleEditUser}
            isEditing={true}
            isLoading={isLoading}
            jobTitles={jobTitles}
            patron={patronDetails}
            setWarnings={setWarnings}
        />
    </>
};




